import BaseCollection from './base_collection';
import Deal from './deal';

// App.Collections.DealsSearch
export default BaseCollection.extend({
  model: Deal,

  url: function () {
    return App.Routes.api_searches_path({
      types: 'deals',
      query: this.options.query
    });
  },

  initialize: function (models, options) {
    this.options = options || {};
  },

  parse: function (data) {
    if (data.counts) {
      this.total = data.counts.deals;
    }

    if (data.records) {
      return data.records.deals;
    }

    return data;
  }
});
